var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('Header'),_c('router-view',{staticClass:"router-view",style:({minHeight: _vm.Height+'px'}),attrs:{"id":"v-content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }